import { Table } from 'antd';
import React from 'react';

import { ConfirmDeletingElement, EditSalesFunnelModal } from '@app/components';
import { PREFIX, SALES_FUNNELS_HEADER, U_KEY } from '@app/constants';

import { CreateFunnelModal } from '@pages/SalesFunnels/SalesFunnelsRegistry/components/CreateFunnelModal';

import { TableHeader } from '@pages/SalesFunnels/SalesFunnelsRegistry/components';
import {
  useSalesFunnelsEffects,
  useSalesFunnelsRegistry,
} from '@pages/SalesFunnels/SalesFunnelsRegistry/hooks';

import '@pages/SalesFunnels/SalesFunnelsRegistry/styles/SalesFunnels.desktop.scss';

export const SalesFunnels = () => {
  const {
    isEditSalesFunnelModalOpen,
    setIsEditSalesFunnelModalOpen,
    editableSalesFunnelId,
    currentSalesFunnelStage,
    setCurrentSalesFunnelStage,
    isEditModal,
    headerForm,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleDeleteSalesFunnelStageClick,
    getSalesFunnelsListHandler,
    searchedSalesFunnelsList,
    confirmDeletingContent,
    isListLoading,
    handleResetForm,
    handleSearch,
    dataSource,
    handleDelete,
    confirmDeletingTitle,
    isCreateModalOpen,
    setIsCreateModalOpen,
    isStageDeletionLoading,
  } = useSalesFunnelsRegistry();

  useSalesFunnelsEffects({ getSalesFunnelsListHandler });

  return (
    <div className={`${PREFIX}sales-funnels`}>
      <TableHeader
        headerForm={headerForm}
        handleResetForm={handleResetForm}
        handleSearch={handleSearch}
      />

      <Table
        className="sales-funnels-table"
        columns={SALES_FUNNELS_HEADER}
        loading={isListLoading}
        dataSource={dataSource}
        pagination={false}
        rowKey={U_KEY}
        scroll={{ x: 'max-content' }}
      />

      <EditSalesFunnelModal
        isEditSalesFunnelModalOpen={isEditSalesFunnelModalOpen}
        setIsEditSalesFunnelModalOpen={setIsEditSalesFunnelModalOpen}
        salesFunnelId={editableSalesFunnelId}
        salesFunnelsList={searchedSalesFunnelsList}
        currentSalesFunnelStage={currentSalesFunnelStage}
        setCurrentSalesFunnelStage={setCurrentSalesFunnelStage}
        isEditModal={isEditModal}
        refetchListData={getSalesFunnelsListHandler}
        headerForm={headerForm}
        handleDeleteSalesFunnelStageClick={handleDeleteSalesFunnelStageClick}
        isRegistryComponent={true}
      />

      <ConfirmDeletingElement
        modalOpen={isDeleteModalOpen}
        setModalOpen={setIsDeleteModalOpen}
        handleDelete={handleDelete}
        content={confirmDeletingContent}
        title={confirmDeletingTitle}
        isStageDeletionLoading={isStageDeletionLoading}
      />

      <CreateFunnelModal
        setIsModalOpen={setIsCreateModalOpen}
        isModalOpen={isCreateModalOpen}
        refetchRegistryListData={getSalesFunnelsListHandler}
      />
    </div>
  );
};
